import {createFileRoute, redirect} from "@tanstack/react-router";
import {isAuthenticated} from "../../../../utils/auth.ts";
import Layout from "../../../../components/Layouts/Layout.tsx";
import NoteTypeDetailContent from "../../../../components/Settings/NoteTypeDetailContent.tsx";

export const Route = createFileRoute('/settings/notes/manage/$noteTypeId')({
  beforeLoad: async () => {
    if (!isAuthenticated()) {
      throw redirect({to: '/', replace: true});
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const {noteTypeId} = Route.useParams();
  return (
    <Layout>
      <NoteTypeDetailContent noteTypeId={Number(noteTypeId)} />
    </Layout>
  );
}
